/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2022-06-07 15:23:45
 * @Description:
 */
// import { login } from '@/api/system'

import { logout, login } from '@/api/setting'
import { fetchPostSso } from '@/fetch/fetch'
import { SET_TOKEN } from './../mutations-type'
import store from "../store";
import router from '@/router'
import Vue from 'vue'
const Login = {
    state: {},
    mutations: {},

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                //向后台请求数据
                login(userInfo).then(res => {
                    console.log(res)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退出
        LogOut() {
            return new Promise((resolve, reject) => {
                //向后台请求数据
                let $loadingInstance = null
                    // 开启loading
                $loadingInstance = Vue.prototype.$loading()
                logout().then(res => {
                    if (res.success) {
                        $loadingInstance.close();
                        window.sessionStorage.removeItem('data');
                        window.localStorage.removeItem('x-auth-token');
                        store.commit('SET_USER', {});
                        store.commit('SET_MENU', []);
                        // removeToken();
                        router.push('/login');
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default Login